import { useEffect, useState } from 'react';
import { Users } from 'lucide-react';
import { getJSON } from './api';
import { GamePlayersDialog } from './GamePlayersDialog';

// Admin "Game Players" tab: pick any game to see who played it.
export const GamePlayersTab = () => {
    const [games, setGames] = useState([]);
    const [open, setOpen] = useState(null);
    useEffect(() => { getJSON('/admin/games/catalog').then((d) => setGames(d.games)).catch(() => {}); }, []);
    return (
        <div className="space-y-4" data-testid="game-players-tab">
            <div className="flex items-center gap-2"><Users className="w-5 h-5 text-zinc-300" /><h2 className="text-white font-black text-lg">Game Players</h2>
                <span className="text-xs text-zinc-500">Pick a game to see who played it today or in the last 7 days.</span></div>
            <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-6 gap-3">
                {games.map((g) => (
                    <button key={g.id} type="button" onClick={() => setOpen(g.id)} data-testid={`game-players-pick-${g.id}`}
                        className="rounded-xl border border-white/10 bg-black/30 px-3 py-3 text-left text-sm font-bold text-white hover:border-white/30 hover:-translate-y-0.5 transition-transform"
                        style={{ boxShadow: `inset 3px 0 0 ${g.color}` }}>{g.name}</button>
                ))}
            </div>
            <GamePlayersDialog gameId={open} onClose={() => setOpen(null)} />
        </div>
    );
};
